<template>
  <div class="layout-columns-tra-aside">
    <el-scrollbar>
      <ul ref="listRef">
        <li
          v-for="(v, k) in columnsNavList"
          :key="v.path"
          class="layout-columns"
          :class="{ 'layout-columns-active': k === activeColumnIndex }"
          :title="v.title"
          @click="onColumnClick(v)"
        >
          <div class="columns-horizontal">
            <div class="font12">
              {{ v.title && v.title.length >= 4 ? v.title.substr(0, 3) : v.title }}
            </div>
          </div>
        </li>
      </ul>
    </el-scrollbar>
  </div>
</template>

<script setup lang="ts">
import { computed, watch } from 'vue';
import { useRoute } from 'vue-router';
import useCrmebMenuStore from '@/store/modules/menu';
import type { CrmebNavMenuItem } from '@/utils/crmebMenu';

const route = useRoute();
const crmebMenu = useCrmebMenuStore();

const columnsNavList = computed(() => crmebMenu.columnsNavList);
const activeColumnIndex = computed(() => crmebMenu.activeColumnIndex);

function onColumnClick(v: CrmebNavMenuItem) {
  crmebMenu.onColumnClick(v);
}

watch(
  () => route.path,
  () => crmebMenu.syncLayoutByRoute(route),
  { immediate: true },
);
</script>

<style scoped lang="scss">
.layout-columns-tra-aside {
  flex: 1;
  min-width: 0;
  height: 50px;
  ul {
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0 8px;
    height: 50px;
    align-items: center;
    li.layout-columns {
      cursor: pointer;
      padding: 0 12px;
      height: 36px;
      line-height: 36px;
      color: var(--prev-bg-topBarColor, #515a6e);
      border-radius: 4px;
      white-space: nowrap;
      &.layout-columns-active {
        color: var(--prev-color-primary, #4073fa);
        background: var(--prev-color-hover, rgba(0, 0, 0, 0.04));
      }
    }
  }
}
.font12 {
  font-size: 12px;
}
</style>
